import { useGetIdentity, useList, useOne } from "@refinedev/core";
import React, { FC } from "react";
import { AssociationUserShowProvider } from "../../context/user-show.context";
import { ResourceIdentifier } from "../../resources";
import { Association, AssociationUser, User } from "../../sdk";
import { PgaUserCard } from "../members/user-view/pga-user-card";

export const PreviewCards = () => {
  const { data: associations } = useList<Association>({
    resource: ResourceIdentifier.Association,
  });
  return (
    <div className={"flex flex-row gap-10 flex-wrap p-10"}>
      {associations?.data?.map((association) => (
        <PreviewCard key={association.id} association={association} />
      ))}
    </div>
  );
};

export const PreviewCard: FC<{ association: Association }> = ({
  association,
}) => {
  const { data: identity } = useGetIdentity<User>();
  const { data: associationUserData } = useOne<AssociationUser>({
    resource: ResourceIdentifier.AssociationUser,
    id: identity?.associationUsers?.[0]?.id,
    meta: {
      associationId: identity?.associationUsers?.[0]?.associationId,
    },
  });

  // const { data: associationData } = useOne<Association>({
  //   resource: ResourceIdentifier.Association,
  //   id: "ecf2782d-295b-400d-b990-d21c066d024f",
  // });

  return (
    <div className={"h-[600px] max-w-[400px] w-full rounded-2xl text-center"}>
      {!!identity?.associationUsers?.[0] && associationUserData?.data && (
        <AssociationUserShowProvider
          associationUser={{
            ...associationUserData?.data,
            association: association,
            user: associationUserData.data.user,
          }}
        >
          <div className={"text-white"}>
            <PgaUserCard />
          </div>
        </AssociationUserShowProvider>
      )}
    </div>
  );
};
